<template>
  <div>
    <v-dialog
      content-class="list-tarja-dialog"
      v-model="dialog"
      scrollable
      :fullscreen="fullscreen"
    >
      <v-card>
        <v-toolbar color="primary" dark class="d-print-none">
          <v-toolbar-title v-if="trabajador">
            {{ trabajador.nombre }}
            <span class="ml-3 subtitle-2">{{ dateFormated }}</span>
          </v-toolbar-title>

          <v-spacer />
          <v-toolbar-items>
            <v-btn
              :small="isMobile"
              text
              icon
              color="white"
              :disabled="loadingTarjas"
              @click="print()"
            >
              <v-icon>print</v-icon>
            </v-btn>
            <v-btn text icon color="white" @click="cancel()">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>


        <div class="pa-0" style="flex: 1 1 100%">
          <list-tarjas
            :key="keyLista"
            v-model="tarjasSelected"
            style="flex: 1 1 100%;"
            :date-selected="dateSelected"
            :tarja-default="tarjaDefault"
            :tarjas="tarjas"

            :loading="loadingTarjas"
            :contratos="contratos"
            :centros-costo="centrosCosto"
            :labores="sublabores"
            :trabajadores="trabajadores"

            :forced-show-trabajador="forcedShowTrabajador"
            :trabajador-selected="trabajador"
            :with-sidebar-extended="false"
            :add-enabled="false"
            :selectable="false"
            :with-date="true"
            :with-valor-dia="true"
            :with-sidebar-group="false"
            :with-duplicate="false"
            order-list-by="fecha"
            @change="onChange"
          />
        </div>

        <v-divider />
      </v-card>
    </v-dialog>
  </div>
</template>
<script>

import _ from 'lodash';
import moment from 'moment';
import axios from 'axios';
import tarjaModel from "@/models/tarjaModel";
import trabajadorModel from "@/models/trabajadorModel";
import tipoContratoModel from "@/models/tipoContratoModel"
import listTarjas from "@/components/listTarjasNative";

export default {
  name: "ListTarjaDialog",
  components : {
    listTarjas,
  },
  props         : {
    value                : {default : false    , type: Boolean},
    trabajador           : {default : () => [] , type: Array},
    centrosCostoDialog   : {default : () => [] , type: Array},
    laboresDialog        : {default : () => [] , type: Array},
    subLaboresDialog     : {default : () => [] , type: Array},
    dates                : {default : () => {} , type: Object},
    forcedShowTrabajador : {default : true     , type: Boolean},
    fullscreen           : {default : false    , type: Boolean},
  },
  data: () => ({
    dialog       : false,
    dateSelected : moment().format("YYYY-MM-DD"),  //test
    keyLista     : 0,


    tarjas        : [], // <<<<< desde peticion
    centrosCosto  : [], // List
    contratos     : [], // List
    sublabores    : [], // List
    trabajadores  : [], // List

    tarjasSelected : [],
    loadingTarjas  : false,
    tarjaDefault   : {     //obtenida desde tarjaListPersonas2

      asistencia_id   : null,
      centro_costo_id : null,
      sub_labor_id    : null,
      trabajador_id   : null,
      trabajador      : null,

      horas_extras    : null,
      jornada         : null,
      rendimiento     : null,
      valor_total     : null,
      valor_unidad    : null,
      bono            : null,
    },
    errorMsgModel       : {
      jornada      : false,
      valor_total  : false,
      trabajador   : false,
      sublabor     : false,
      centrosCosto : false,
    }
  }),
  computed:{
    empresaSelected(){
      return this.$store.getters.empresaSelected;
    },
    isMobile(){
      return this.$store.getters.isMobile;
    },
    dateFormated(){
      let date = null;
      if(this.dates.date){
        date =moment(this.dates.date, "YYYY-MM-DD").format("D [de] MMMM")
      }
      if(this.dates.dateInicio && this.dates.dateFin){
        date = moment(this.dates.dateInicio, "YYYY-MM-DD").format(this.isMobile ?  "DD/MM" : "D [de] MMMM") + " - "+
              moment(this.dates.dateFin, "YYYY-MM-DD").format(this.isMobile ?  "DD/MM" : "D [de] MMMM")
      }
      return date;
    }
  },
  watch:{
    value(){
      this.dialog = this.value;
      this.keyLista++;
    },
    dialog(){
      if(this.dialog){
        this.getData()
      }
      this.$emit("input", this.dialog);
    },
    trabajador(){
      console.log("trabajador change");
    },
    dates(){
      console.log("dates change");
      this.dateSelected = null;
      if(this.dates.date){
        this.dateSelected = this.dates.date;
      }
      if(this.dates.dateInicio){
        this.dateSelected = this.dates.dateInicio;
      }
    },
  },
  created() {
    //do something after creating vue instance
    if(this.value == true){
      this.dialog = true;
    }
  },
  methods: {
    refreshTarjas(){
      // TODO: considerar tarjas nuevas isNew=true , ya que no estan guardadas
      var tarjasNew = _.filter(this.tarjas, {isNew: true});

      return this.getTarjas().then( () => {
        this.prepareContratos();
        this.prepareTarjas();
        this.tarjas = this.tarjas.concat(tarjasNew);
        this.keyLista++;
      })
    },
    getData(){
      if(this.empresaSelected){
        this.loadingTarjas = true;
        axios.all([
          this.getTarjas(),
          this.getTipoContratos(),
          this.getTrabajadores()
        ]).then( () => {
          //this.prepareLabores();
          this.prepareContratos();
          this.prepareTarjas();
          this.keyLista++; //HACK para actualizar lista
          this.loadingTarjas = false;
        }, function(resError){
          console.error(resError);
          this.loadingTarjas = false;
        })
      }else{
        console.log("getData this.empresa no selected");
      }
    },


    prepareTarjas(){
      console.log("prepareTarjas");
      _.forEach(this.tarjasOriginal, tarja => {
        this.prepareTarja(tarja);
      });
      this.tarjas = _.orderBy(_.cloneDeep(this.tarjasOriginal), "fecha");
      console.log("prepareTarjas DONE");
    },
    prepareTarja(tarja){
        tarja.centrosCosto = _.find(this.centrosCosto, {id: tarja.centro_costo_id});
        tarja.asistencia   = _.find(this.asistencias, {id: tarja.asistencia_id});
        tarja.sublabor     = _.find(this.sublabores , {id: tarja.sub_labor_id});
        tarja.trabajador   = _.find(this.trabajadores , {id: tarja.trabajador_id});
        tarja.isNew        = false;
        tarja.loading      = false;
        tarja.error        = false;
        tarja.type         = "D";
        tarja.errorMsg     = _.clone(this.errorMsgModel);
        tarja.cleanErrorMsg = function(tarja){
          tarja.errorMsg     = _.clone(this.errorMsgModel);
        }.bind(this)

          if(tarja.horas_extras == 0){
            tarja.horas_extras = null;
          }
          if(tarja.valor_unidad == 0){
            tarja.valor_unidad = null;
          }
          if(tarja.bono == 0){
            tarja.bono = null;
          }
          if(tarja.rendimiento == 0){
            tarja.rendimiento = null;
          }

    },

    prepareContratos(){
      console.log("prepareContratos");
      _.forEach(this.contratos, contrato => {
        contrato.tipoContrato = _.find(this.tiposContrato , {id: contrato.tipo_contrato_id});
      })
      _.forEach(this.trabajadores, tr => {
        tr.contrato = _.find(this.contratos, {trabajador_id: tr.id});
      })
    },

    getTrabajadores(){
      console.log("getTrabajadores");
      var p = trabajadorModel.all({ params:{
        empresa_id : this.empresaSelected.id,
      }});
      p.then(res => {
      console.log("getTrabajadores DONE");
        this.trabajadores = res.data.data;
        _.forEach(this.trabajadores, tr => {
          tr.codname = tr.nombre;
          if(tr.codigo && tr.codigo.length > 1){
            tr.codname = tr.codigo;
          }
        })
      }, resError =>{
        console.error(resError);
      });
      return p;
    },
      getTarjas(){
      var self = this;
      console.log("getData")
      var params = {
        empresa_id   : self.empresaSelected.id,
      };
      if(this.trabajador){
        params.trabajador_id = this.trabajador.id;
      }
      if(this.dates.date){
        params.fecha_inicio = this.dates.date;
      }
      if(this.dates.dateInicio){
        params.fecha_inicio = this.dates.dateInicio;
      }
      if(this.dates.dateFin){
        params.fecha_fin = this.dates.dateFin;
      }
      if(this.subLaboresDialog){
        params.sub_labores_id = this.subLaboresDialog;
      }
      if(this.laboresDialog){
        params.labores_id = this.laboresDialog;
      }
      if(this.centrosCostoDialog){
        params.centros_costo_id = this.centrosCostoDialog;
      }
      var p = tarjaModel.all({params})
      p.then(res => {
        console.log("getData DONE");
        self.tarjasOriginal = res.data.data.tarjas;
        self.contratos      = res.data.data.contratos;
        self.sublabores     = _.flatMap(res.data.data.labores, labor=>{
          _.map(labor.sub_labores, sub =>{
            sub.labor = labor;
            sub.codname = sub.nombre;
            if(sub.codigo && sub.codigo.length > 1){
              sub.codname = sub.codigo;
            }
          });
          return labor.sub_labores;
        });
        self.centrosCosto   = res.data.data.centro_costos;
        _.forEach(self.centrosCosto, cc => {
          cc.codname = cc.nombre;
          if(cc.codigo && cc.codigo.length > 1){
            cc.codname = cc.codigo;
          }
        })
      }, resError =>{
        console.error(resError);
      });
      return p;
    },

    getTipoContratos(){
      console.log("getTipoContratos");
      var p = tipoContratoModel.all({ params:{
        empresa_id : this.empresaSelected.id,
      }})
      p.then(res => {
      console.log("getTipoContratos DONE");
        this.tiposContrato = res.data.data;
      }, resError =>{
        console.error(resError);
      });
      return p
    },

    print() {
      window.print();
    },

    showDialog() {
      this.dialog = true;
    },
    cancel(){
      this.dialog = false;
    },
    onChange(tarjas){
      this.refreshTarjas().then( () => {
        this.$emit('change', tarjas);
      })
    }
  }
}
</script>
<style lang="scss" >
  .list-tarja-dialog{
    .table-container .tarjas-container{
      height: calc(100vh - 200px); //patch
    }
  }
  @media print{
    .list-tarja-dialog{
      margin: 0px;
      max-height: 100% !important;
      box-shadow: none;
    }
    .v-dialog__content{
      align-items: flex-start;
      justify-content: start;
      height: auto;
      position: absolute;
    }
  }
</style>
